import type { PickerUser } from '~/pages/backoffice/admin/sessions/components/ParticipantPicker'
import ParticipantPicker from '~/pages/backoffice/admin/sessions/components/ParticipantPicker'
import { trainerCandidates } from '~/pages/backoffice/admin/sessions/trainer-candidates'

type IProps = {
  /** Comptes chargés par le formulaire ; seuls les admins et formateurs sont proposés. */
  users: (PickerUser & { role?: { name: string } | null })[]
  /** Formateurs déjà affectés, proposés même quand le lecteur ne les liste pas. */
  assigned?: PickerUser[] | null
  value: Set<string>
  onChange: (next: Set<string>) => void
}

/** Les formateurs qui animent le parcours (#244), dans son formulaire. */
function SessionTrainersField({ users, assigned, value, onChange }: IProps) {
  return (
    <ParticipantPicker
      users={trainerCandidates(users, assigned ?? [])}
      value={value}
      onChange={onChange}
      labelKey="sessions.trainers.label"
      searchLabelKey="sessions.trainers.search"
    />
  )
}

export default SessionTrainersField
